import * as R from 'ramda'
import { useSelector } from 'react-redux'

export const useDefaultLanguage = () => useSelector(getDefaultLanguage)
export const getDefaultLanguage = R.compose(
  R.defaultTo({ code: 'en', id: 1 }),
  R.head,
  R.defaultTo([]),
  R.path(['auth', 'user', 'data', 'defaultLanguage']),
)

export const getLangaugeId = R.prop('id')
